import { Component, Input } from '@angular/core';
import { NgbActiveModal }   from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector   : 'wor-xero-error',
  template: require('./xero.error.component.html')
})
export class XeroErrorComponent {
  @Input() error : string;

  constructor (
    public activeModal: NgbActiveModal
  ) {}
}
